// extracted by mini-css-extract-plugin
module.exports = {"item":"HomePage_item__2f1lM","section":"HomePage_section__1kQoX"};